import React, { FC, useMemo } from 'react'
import { UISizes, UITypes, FileContentView, FileView, CloseIcon } from 'LibNeo'
import { isImageFile } from 'Helpers'
import { deviceDetect, FileItemProps, FileStatuses } from 'Modules'
import { useSelector } from 'react-redux'

export const File: FC<FileItemProps> = ({
	file,
	deleteFile,
	status = FileStatuses.COMPLETE,
	description,
	showFilePreview,
}) => {
	const isMobile = useSelector(deviceDetect.getIsMobile)

	const { isImage, fileName } = useMemo(
		() => ({
			isImage: isImageFile(file?.name),
			fileName: file?.name,
		}),
		[file?.name]
	)

	const isReadyDeleteFile = deleteFile && status !== FileStatuses.LOADING

	return (
		<FileView file={file} isImage={isImage} isMobile={isMobile}>
			<FileContentView
				file={file}
				fileName={fileName}
				showFilePreview={showFilePreview}
				statusFile={status}
				fileInfo={description}
				renderDeleteFileButton={() =>
					isReadyDeleteFile ? (
						<CloseIcon
							name="close"
							onClick={() => {
								deleteFile?.()
							}}
							type={UITypes.GREY_LIGHT}
							size={UISizes.SMALL}
						/>
					) : null
				}
			/>
		</FileView>
	)
}
